/**
 * BismillahCSS Component Registry
 * Tracking all available components for dynamic inclusion and discovery.
 */
export const bRegistry = {
    v: "1.0.0",
    components: [
        { name: "hero-ultra", type: "layout", version: "3.1.0" },
        { name: "navbar-ultra", type: "layout", version: "3.1.0" },
        { name: "feature-cards-ultra", type: "layout", version: "3.1.0" },
        { name: "sidebar-ultra", type: "layout", version: "3.1.0" },
        { name: "glow-buttons-ultra", type: "primitive", version: "3.1.0" },
        { name: "dashboard-ultra", type: "layout", version: "3.1.0" },
        { name: "pricing-ultra", type: "layout", version: "3.1.0" },
        { name: "table-ultra", type: "atom", version: "3.1.0" },
        { name: "btn-glass-ultra", type: "atom", version: "3.1.0" },
        { name: "badge-neon-ultra", type: "atom", version: "3.1.0" },
        { name: "input-cyber-ultra", type: "atom", version: "3.1.0" },
        { name: "card-gradient-ultra", type: "molecule", version: "3.1.0" },
        { name: "aurora-bg-elite", type: "layout", version: "3.1.0" },
        { name: "tooltip-cyber-elite", type: "atom", version: "3.1.0" },
        { name: "input-elite-ultra", type: "atom", version: "3.1.0" },
        { name: "card-float-elite", type: "molecule", version: "3.1.0" },
        { name: "card-royal-elite", type: "molecule", version: "3.1.0" },
        { name: "btn-royal-elite", type: "atom", version: "3.1.0" },
        { name: "card-prism-elite", type: "molecule", version: "3.1.0" },
        { name: "progress-vapor-elite", type: "atom", version: "3.1.0" },
        { name: "card-vapor-elite", type: "molecule", version: "3.1.0" },
        { name: "b-glass", type: "primitive", version: "3.1.0" },
        { name: "b-neumorphic", type: "primitive", version: "3.1.0" },
        { name: "b-skeuo", type: "primitive", version: "3.1.0" },
        { name: "b-brutalist", type: "primitive", version: "3.1.0" },
        { name: "b-cyber-neon", type: "primitive", version: "3.1.0" },
        { name: "b-clay", type: "primitive", version: "3.1.0" }
    ]
};

export const getRegistry = () => bRegistry;
export const queryRegistry = (name: string) => bRegistry.components.find(c => c.name === name);
